import React from 'react';

export interface TheoryQuestionData {
    id: string;
    stage_id: string;
    order_index: number;
    question: string;
    choices: { a: string; b: string; c: string; d: string };
    answered: boolean;
    // Only present once `answered` is true (revealed by the backend after the fact).
    correct_choice?: 'a' | 'b' | 'c' | 'd';
    explanation?: string | null;
}

export interface TheoryStageData {
    id: string;
    category: string;
    slug: string;
    title: string;
    order_index: number;
    points: number;
    active: boolean;
    solved: boolean;
    locked: boolean;
}

export interface ContentBlock {
    type: 'content';
    key: string;
    render: () => React.ReactNode;
}

export interface QuestionBlock {
    type: 'question';
    /** Positional index (0-based) into the stage's questions, ordered by order_index. */
    n: number;
}

export type StageBlock = ContentBlock | QuestionBlock;

export const content = (key: string, render: () => React.ReactNode): ContentBlock => ({
    type: 'content',
    key,
    render,
});

export const question = (n: number): QuestionBlock => ({ type: 'question', n });
